/* su-variant-media-filter.js — StyleUp.Today
   On a product page, filter the media gallery by the selected color:
   show only that color's photos (matched via image alt text) plus any
   color-agnostic photos (no color name in alt, e.g. lifestyle shots).
   Also moves the "featured" (full-width) class to the first VISIBLE item so
   the featured-first layout still works after filtering. Safe no-op on pages
   without a product gallery, and on products whose alts lack color names. */
(function () {
  function colorFieldset() {
    var fss = document.querySelectorAll('.product-form fieldset, variant-radios fieldset, variant-selects fieldset, fieldset');
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector('legend, label');
      if (lg && /colou?r/i.test(lg.textContent || '')) return fss[i];
    }
    return null;
  }
  function colorList(fs) {
    var s = []; if (!fs) return s;
    fs.querySelectorAll('input[type="radio"], option').forEach(function (el) {
      var v = (el.value || '').trim();
      if (v && s.indexOf(v) === -1) s.push(v);
    });
    return s;
  }
  function selectedColor(fs) {
    if (!fs) return null;
    var c = fs.querySelector('input[type="radio"]:checked');
    if (c) return (c.value || '').trim();
    var sel = fs.querySelector('select');
    if (sel) return (sel.value || '').trim();
    return null;
  }
  function colorOfAlt(alt, colors) {
    var found = null, a = (alt || '').toLowerCase();
    for (var i = 0; i < colors.length; i++) {
      var c = colors[i].toLowerCase();
      if (c && a.indexOf(c) !== -1) { if (!found || c.length > found.length) found = c; }
    }
    return found;
  }
  function suIsSAC() { return !!document.querySelector('.su-pdp'); }
  function suIsSizechart(img) {
    if (!img) return false;
    var s = (img.getAttribute('src') || '') + ' ' + (img.currentSrc || '') + ' ' + (img.src || '') + ' ' + (img.getAttribute('data-src') || '') + ' ' + (img.getAttribute('srcset') || '');
    return /sizechart/i.test(s);
  }
  function apply() {
    var g = document.querySelector('.product__media-list');
    if (!g) return;
    var fs = colorFieldset();
    var colors = colorList(fs);
    var sel = (selectedColor(fs) || '').toLowerCase();
    if (!colors.length || !sel) return;
    var items = g.querySelectorAll('.product__media-item');
    var firstVisible = null;
    items.forEach(function (it) {
      var img = it.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var c = colorOfAlt(alt, colors);
      var show = !(suIsSAC() && suIsSizechart(img)) && (/\bworn\b/i.test(alt) || (c === null) || (c === sel));
      it.classList.toggle('su-hidden', !show);
      if (show && !firstVisible) firstVisible = it;
    });
    items.forEach(function (it) { it.classList.toggle('su-featured', it === firstVisible); });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  function init() {
    if (!document.querySelector('.product__media-list')) return;
    apply();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form, variant-radios, variant-selects, fieldset')) schedule();
    }, true);
    var g = document.querySelector('.product__media-list');
    if (g && window.MutationObserver) {
      new MutationObserver(schedule).observe(g, { childList: true, subtree: true });
    }
    function enforceLifestyle() {
      var items = document.querySelectorAll('.product__media-list .product__media-item');
      var sac = suIsSAC();
      for (var i = 0; i < items.length; i++) {
        var im = items[i].querySelector('img');
        if (!im) continue;
        if (sac && suIsSizechart(im)) {
          if (items[i].style.display !== 'none') items[i].style.display = 'none';
          if (!items[i].classList.contains('su-hidden')) items[i].classList.add('su-hidden');
          continue;
        }
        if (/\bworn\b/i.test(im.getAttribute('alt') || '')) {
          if (items[i].style.display === 'none') items[i].style.display = '';
          if (items[i].classList.contains('su-hidden')) items[i].classList.remove('su-hidden');
        }
      }
    }
    enforceLifestyle();
    if (g && window.MutationObserver) {
      new MutationObserver(enforceLifestyle).observe(g, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
